import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isOwner',
  standalone: true,
})
export class IsOwnerPipe implements PipeTransform {
  transform(owner: [], id: any): any {
    return owner.some((m: any) => m?.user_id == id || m?.detail?.user_id == id);
  }
}
